import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'

export default {
  data () {
    return {

    }
  },
  methods: {

    submit () {
      this.$message.success('购买成功!')
      setTimeout(this.$router.go(-1), 3000)
    }
  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/extended-insurance/extended-insurance.js